import { render } from "./BaseFormSelect.vue?vue&type=template&id=5a06d188"
import script from "./BaseFormSelect.vue?vue&type=script&lang=js"
export * from "./BaseFormSelect.vue?vue&type=script&lang=js"

import exportComponent from "/home/projects/cc-gastro/htdocs/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/BaseFormSelect.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5a06d188"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5a06d188', __exports__)) {
    console.log('reload')
    api.reload('5a06d188', __exports__)
  }
  
  module.hot.accept("./BaseFormSelect.vue?vue&type=template&id=5a06d188", () => {
    console.log('re-render')
    api.rerender('5a06d188', render)
  })

}


export default __exports__